// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1Oxrb","range":"MonthRangeSwitch_range__2CMnC","disabled":"MonthRangeSwitch_disabled__L2ldk"};